import React from 'react';
import './TermsAndConditionsSection.css';

const TermsAndConditionsSection: React.FC = () => {
  return (
    <div className="terms-and-conditions-section">
      <div className="terms-container">
        {/* Header Section */}
        <div className="terms-header">
          <h1 className="terms-title">Terms and Conditions</h1>
          <p className="terms-subtitle">For more information, please get in touch with us.</p>
        </div>

        {/* Main Content */}
        <div className="terms-content">
          <div className="terms-text">
            <p>
              Pacific Cross Philippines (PCPH) owns and operates this website. Hereinafter, "we", "our" and "us" refer to Pacific 
              Cross and "you" and "your" as customer. By using the Services on this website, you AGREE that you have read, 
              understood, and accepted all these Terms of Service. This will be updated by us from time to time. You should review 
              the agreement periodically to be aware of such modifications, and you're accessing or using the service constitutes 
              your acceptance of the agreement as it appears at the time of your access or use. We preserve the right to revoke or 
              amend the Services and Terms of Service without prior notice. If the website contains links to other sites and 
              resources provided by third parties, these links are provided for your convenience only. We have no control over the 
              contents of those third-party sites or resources and accept no responsibility for these sites nor their contents nor 
              for any loss or damage that may arise from your use of such third-party sites and resources. If you decide to access 
              any of the third-party websites linked to our website, you do so entirely at your own risk and subject to the terms and 
              conditions of use for such websites.
            </p>
          </div>

          {/* Privacy Policy Section */}
          <div className="terms-section">
            <h2 className="section-title">Privacy Policy</h2>
            <p className="section-text">
              Your personally identifiable information that we may collect is subject to our Data Privacy Policy, which is 
              incorporated into these Terms and Conditions by reference.
            </p>
          </div>

          {/* Security Section */}
          <div className="terms-section">
            <h2 className="section-title">Security</h2>
            <p className="section-text">
              While we provide internet web security technologies and use other reasonable precautions to protect confidential 
              information and provide suitable security, we do not guarantee or warrant that information transmitted through the 
              internet is secure, or that such transmissions will be free from delay, interruption, interception, or error. Finally, you 
              acknowledge and agree that you will not transmit any material that contains viruses or files or programs that might 
              interrupt, limit, or interfere with the functionality of our website, database used by the Company.
            </p>
          </div>

          {/* Cookies Section */}
          <div className="terms-section">
            <h2 className="section-title">Cookies</h2>
            <p className="section-text">
              We use "cookies" to enhance your access to our website. A cookie is a small amount of data that is sent to your 
              browser from a web server and stored on the hard drive of your computer or mobile communications device. Cookies 
              do not store personal information about you unless you knowingly provide it. Cookies can store non-personal 
              information, such as what web site pages or advertisements your browser has accessed. We use cookies to store 
              information and personalize your experience with our web site.
            </p>
          </div>

          {/* Jurisdiction Section */}
          <div className="terms-section">
            <h2 className="section-title">Jurisdiction</h2>
            <p className="section-text">
              You agree that any dispute, any legal suit, action or proceeding arising out of, or related to, these Terms of Service 
              related to your use of the Pacific Cross Site is subject to the exclusive jurisdiction of the appropriate court in Makati 
              City, Philippines. This agreement also applies to anyone claiming on your behalf.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditionsSection;